// @flow
import * as constants from './constants';
import { createAction } from 'redux-actions';

export const loadDevices = createAction(constants.LOAD_DEVICES);
export const loadInstallOptions = createAction(constants.LOAD_INSTALL_OPTIONS);
export const loadManageDevices = createAction(constants.LOAD_MANAGE_DEVICES);
export const receiveDevices = createAction(constants.RECEIVE_DEVICES);
export const removeDevice = createAction(constants.REMOVE_DEVICE);
export const removeDeviceError = createAction(constants.REMOVE_DEVICE_ERROR);
export const removeZone = createAction(constants.REMOVE_ZONE);
export const removedDevice = createAction(constants.REMOVED_DEVICE);
export const removedZone = createAction(constants.REMOVED_ZONE);
export const renameDevice = createAction(constants.RENAME_DEVICE);
export const renameHubDevices = createAction(constants.RENAME_HUB_DEVICES);
export const renameZone = createAction(constants.RENAME_ZONE);
export const renamedDevice = createAction(constants.RENAMED_DEVICE);
export const renamedZone = createAction(constants.RENAMED_ZONE);
export const requestDevices = createAction(constants.REQUEST_DEVICES);
export const restartHub = createAction(constants.RESTART_HUB);
export const restartedHub = createAction(constants.RESTARTED_HUB);



// WEBPACK FOOTER //
// ./src/core/state/devices/actions.js